import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'

import AlertDialog from './AlertDialog';

import { setGeneralNoticeDismissed } from '../actions';

const GeneralNotice = () => {
	const dispatch = useDispatch();
	
	const memberSettings = useSelector(state => state.settings.members.data);
	const user = useSelector(state => state.user);
	const noticeDismissed = useSelector(state => state.generalNoticeDismissed);
	const timedOut = useSelector(state => state.timedOutLoggedOut);
	
	const [noticeRequired, setNoticeRequired] = useState(false);
	useEffect(() => {
		
		let r = false; 
		if(!noticeDismissed && !timedOut && (
			(user.member_no > 0 && memberSettings.general_message_member) ||
			(user.member_no === 0 && memberSettings.general_message_join)
		)){
			r = true;
		}
		setNoticeRequired(r);
		
	}, [user, noticeDismissed, timedOut, memberSettings])

	return noticeRequired ? 
		<AlertDialog 
			noBackdropClick={true}
			title={user.member_no > 0 ? 'Important Information' : 'Message for New Members'}
			message={user.member_no > 0 ? memberSettings.general_message_member : memberSettings.general_message_join}
			handleClose={() => dispatch(setGeneralNoticeDismissed(true))}
		/> : 
		null;
}

export default GeneralNotice